import fetcher_v2 from "@/api/fetcher_v2";
import { Article, RecentEvent } from "@/types/Dashboard";

import { URLS } from "../urls";

export const getDashboardData = () => {
  return fetcher_v2<{
    recent_events: RecentEvent[];
    articles: {
      checklist_articles: Article[];
      help_articles: Article[];
      tips_articles: Article[];
    };
  }>(URLS.DASHOARD);
};

export const getReadDashboardArticles = () => {
  return fetcher_v2<{ read_dashboard_articles: number[] }>(
    URLS.READ_DASHBOARD_ARTICLES
  );
};

export const setReadDashboardArticle = (articleId: number) => {
  return fetcher_v2<string[]>(URLS.READ_DASHBOARD_ARTICLES, {
    body: { article_id: articleId },
    method: "PUT",
  });
};
